import { Button, colors, IMFormModal, typography } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const FormFieldSelectStyled = styled.div`
  width: 100%;
  margin-top: 3.6rem;
  text-align: left;
`;

export const ButtonStyled = styled(Button)`
  padding-left: 0;
`;

export const MegaWideButtonWrapper = styled.div`
  width: 100%;
  padding-top: 2rem;
`;

export const SectionCategoryStyled = styled.p`
  ${typography.regular[12]}
  margin: 0;
  width: 100%;
  text-align: left;
  color: ${colors.neutral[700]};
  text-transform: uppercase;
  border-bottom: 1px solid ${colors.neutral[300]};
  padding-bottom: 1rem;
`;

export const IMFormModalStyled = styled(IMFormModal)`
  min-width: 75rem;
`;
